import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
	selector: "ic-terms-conditions-text",
	templateUrl: "./terms-conditions-text.component.html",
	styleUrls: ["./terms-conditions-text.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TermsAndConditionsTextComponent {}
